import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {Success} from "@portal/api/responses/api-response";
import { Tag } from './contracts/tags/tag';
import {ApiBaseService} from "@portal/api/api-base-service";
import {Guid} from "guid-typescript";

@Injectable({
    providedIn: 'root',
})
export class TagService extends ApiBaseService {
    controller = 'v1/tags';

    constructor(public http: HttpClient) {
        super(http);
    }

    getTags(): Observable<Success<Tag[]>> {
        return this.get<Success<Tag[]>>(this.controller);
    }

    createTag(tag: Tag): Observable<Success<Tag>> {
        return this.post<Success<Tag>, Tag>(tag, this.controller);
    }

    updateTag(tag: Tag): Observable<Success<Tag>> {
        return this.put<Success<Tag>, Tag>(tag,`${this.controller}/${tag.id}`);
    }

    deleteTag(id: Guid): Observable<Success<boolean>> {
        return this.deleteBase<Success<boolean>>(`${this.controller}/${id}`);
    }

    updateTagsOrder(tags: Tag[]): Observable<Success<boolean>> {
        return this.put<Success<boolean>, Tag[]>(tags,`${this.controller}/update-order`);
    }

    updateTagColor(tag: Tag): Observable<Success<boolean>> {
        return this.put<Success<boolean>, Tag>(tag,`${this.controller}/update-color`);
    }
}
